import PropTypes from 'prop-types'
import styled from 'styled-components'

export const StyledHeaderOptimization = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  min-height: 56px;
  
  .etb-btn {
    border: none;
    cursor: pointer;
    background-color: Transparent;
    svg {
      transform: rotate(90deg);
      fill: var(--color-neutral-400) !important;
    }

  }
  
  .etb-btn:active{
    border: none;
 
  }
  
  .etb-btn:focus {
    outline:0;
  }

  .etb-values {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;

    .etb-column {
      color: var(--color-contrast-black);
    }
  }

  .etb-column-optimization {
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    box-sizing: border-box;
    min-width: 0;
    color: var(--color-contrast-black);
  }
`;

StyledHeaderOptimization.propTypes = {
  showCheckbox: PropTypes.bool,
}
